import React, { useState, useEffect } from 'react';
import { Card, Button, Row, Col, Badge, Spinner, Alert, Modal, Form } from 'react-bootstrap';
import axios from 'axios';

export default function AdminApprovalPanel() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [actionLoading, setActionLoading] = useState(null);
  const [rejectTarget, setRejectTarget] = useState(null);
  const [rejectReason, setRejectReason] = useState('');

  const token = localStorage.getItem('token');

  const fetchOrders = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axios.get('https://api.mfrbuild.com/api/v1/billing/pending-receipts', {
        headers: { 'x-auth-token': token },
      });
      setOrders(data);
    } catch (err) {
      setError(err.response?.data?.message || 'Access denied ya kuch masla ho gaya.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleApprove = async (orderId) => {
    setActionLoading(orderId);
    try {
      await axios.post(
        `https://api.mfrbuild.com/api/v1/billing/${orderId}/approve`,
        {},
        { headers: { 'x-auth-token': token } }
      );
      setOrders((prev) => prev.filter((o) => o._id !== orderId));
    } catch (err) {
      alert(err.response?.data?.message || 'Approve karne mein masla hua.');
    } finally {
      setActionLoading(null);
    }
  };

  const openRejectModal = (order) => {
    setRejectTarget(order);
    setRejectReason('');
  };

  const handleReject = async () => {
    if (!rejectTarget) return;
    setActionLoading(rejectTarget._id);
    try {
      await axios.post(
        `https://api.mfrbuild.com/api/v1/billing/${rejectTarget._id}/reject`,
        { reason: rejectReason || 'Receipt invalid ya amount match nahi hua.' },
        { headers: { 'x-auth-token': token } }
      );
      setOrders((prev) => prev.filter((o) => o._id !== rejectTarget._id));
      setRejectTarget(null);
    } catch (err) {
      alert(err.response?.data?.message || 'Reject karne mein masla hua.');
    } finally {
      setActionLoading(null);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4">
        <Alert variant="danger">{error}</Alert>
      </div>
    );
  }

  return (
    <div className="p-3 p-md-4" style={{ maxWidth: 1000, margin: '0 auto' }}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="fw-bold mb-0">Payment Approvals</h3>
        <Button variant="outline-secondary" size="sm" onClick={fetchOrders}>
          🔄 Refresh
        </Button>
      </div>

      {orders.length === 0 ? (
        <Alert variant="secondary">Koi pending receipt nahi hai filhal.</Alert>
      ) : (
        <Row className="g-3">
          {orders.map((order) => (
            <Col xs={12} key={order._id}>
              <Card className="shadow-sm">
                <Card.Body>
                  <Row>
                    <Col md={4}>
                      <a href={order.receiptUrl} target="_blank" rel="noopener noreferrer">
                        <img
                          src={order.receiptUrl}
                          alt="Receipt"
                          style={{ width: '100%', maxHeight: 220, objectFit: 'cover', borderRadius: 8 }}
                        />
                      </a>
                    </Col>
                    <Col md={8}>
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div>
                          <h5 className="mb-1">{order.userId?.name || 'N/A'}</h5>
                          <div className="text-muted small">{order.userId?.email}</div>
                          <div className="text-muted small">{order.userId?.phone}</div>
                          {order.userId?.company && (
                            <div className="text-muted small">{order.userId.company}</div>
                          )}
                        </div>
                        <Badge bg="primary" className="fs-6">
                          {order.planKey?.toUpperCase()}
                        </Badge>
                      </div>

                      <div className="mb-2">
                        <strong>Amount Expected:</strong> Rs {order.amount?.toLocaleString()}
                      </div>
                      <div className="text-muted small mb-3">
                        Submitted: {new Date(order.createdAt).toLocaleString()}
                      </div>

                      <div className="d-flex gap-2">
                        <Button
                          variant="success"
                          disabled={actionLoading === order._id}
                          onClick={() => handleApprove(order._id)}
                        >
                          {actionLoading === order._id ? <Spinner size="sm" /> : '✅ Approve'}
                        </Button>
                        <Button
                          variant="outline-danger"
                          disabled={actionLoading === order._id}
                          onClick={() => openRejectModal(order)}
                        >
                          ❌ Reject
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      <Modal show={!!rejectTarget} onHide={() => setRejectTarget(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Reject Reason</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Wajah likhein (optional)"
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setRejectTarget(null)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleReject} disabled={actionLoading === rejectTarget?._id}>
            {actionLoading === rejectTarget?._id ? <Spinner size="sm" /> : 'Reject Karein'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}